import React, { FC } from 'react';
import classnames from 'classnames';
import { motion } from 'framer-motion';
import { Alert, Button } from '@clearcover/atlas';
import styles from './styles.module.css';

export const Footer: FC<{ hasSecondaryMenu: boolean }> = ({
  hasSecondaryMenu,
  children,
}) => {
  return (
    <motion.div
      initial={{ y: 66 }}
      animate={{ y: 0 }}
      exit={'collapsed'}
      className={classnames(styles.footer, {
        [styles.withSecondaryMenu]: hasSecondaryMenu,
      })}
    >
      {children}
    </motion.div>
  );
};

type FormFooterProps = {
  error?: string;
  disabled: boolean;
  isSubmitting: boolean;
  hasSecondaryMenu?: boolean; // need to determine styling
  buttonText?: string;
  onCancel?: () => void;
};
// TODO: Refactor to take className so the padding/left properties
// aren't set according to if you have secondary menu or not.

export const FormActionFooter: FC<FormFooterProps> = ({
  disabled,
  isSubmitting,
  error,
  hasSecondaryMenu = true,
  buttonText = 'Save',
  onCancel,
}) => {
  const prettyError = error?.replace('GraphQL error: ', '');
  return (
    <Footer hasSecondaryMenu={hasSecondaryMenu}>
      <div className={styles.formFooter}>
        <div className={styles.footerError}>
          {prettyError && (
            <Alert
              message={prettyError}
              data-testid="admin-footer-error-message"
            />
          )}
        </div>
        <div className={styles.actions}>
          {onCancel && (
            <Button
              type="button"
              data-testid="cancel"
              onClick={onCancel}
              variant="secondary"
            >
              Cancel
            </Button>
          )}
          <Button
            disabled={disabled}
            type="submit"
            isSubmitting={isSubmitting}
            data-testid="submit"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </Footer>
  );
};
